module.exports = __webpack_public_path__ + "static/Montserrat-SemiBoldItalic-d41c0a341637c2e35ae019730b2d45a5.ttf";